function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import React from 'react';
import Box from '../../../box';
import ResponsiveLazyImage from '../../../lazy-image';
import styles from './styles.module.scss';

var CardImage = function CardImage(_ref) {
  var desktopImage = _ref.desktopImage,
      mobileImage = _ref.mobileImage,
      externalImage = _ref.externalImage,
      externalImageAlt = _ref.externalImageAlt,
      externalImageWidth = _ref.externalImageWidth,
      externalImageHeight = _ref.externalImageHeight,
      _ref$fade = _ref.fade,
      fade = _ref$fade === void 0 ? true : _ref$fade,
      _ref$lazyLoadingEnabl = _ref.lazyLoadingEnabled,
      lazyLoadingEnabled = _ref$lazyLoadingEnabl === void 0 ? true : _ref$lazyLoadingEnabl,
      _ref$imageFit = _ref.imageFit,
      imageFit = _ref$imageFit === void 0 ? 'cover' : _ref$imageFit,
      _ref$imgContainerClas = _ref.imgContainerClassName,
      imgContainerClassName = _ref$imgContainerClas === void 0 ? '' : _ref$imgContainerClas,
      imageWrapperComponent = _ref.imageWrapperComponent;
  var mergedCardClassName = classNames(styles.cardImageContainer, _defineProperty({}, styles['fade'], fade));
  var mergedImageClassName = classNames(styles.cardImage, [styles[imageFit]]);

  var Image = function Image() {
    return /*#__PURE__*/React.createElement("img", {
      alt: externalImageAlt || '',
      className: styles.externalImage,
      "data-testid": "test-external-image",
      src: externalImage,
      width: externalImageWidth,
      height: externalImageHeight
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: mergedCardClassName,
    "data-testid": "card-image"
  }, externalImage ? /*#__PURE__*/React.createElement(Box, {
    desktopDisplay: "block",
    mobileDisplay: "block",
    tabletDisplay: "block",
    className: imgContainerClassName,
    fullHeight: true
  }, imageWrapperComponent ? imageWrapperComponent( /*#__PURE__*/React.createElement(Image, null)) : /*#__PURE__*/React.createElement(Image, null)) : (desktopImage || mobileImage) && /*#__PURE__*/React.createElement(ResponsiveLazyImage, {
    lazyLoadingEnabled: lazyLoadingEnabled,
    fallbackUrl: desktopImage || mobileImage,
    additionalResponsiveProps: {
      desktop: {
        url: "".concat(desktopImage || mobileImage),
        className: mergedImageClassName
      },
      mobile: {
        url: "".concat(mobileImage || desktopImage),
        className: mergedImageClassName
      }
    }
  }));
};

export default CardImage;